export class TrialSupportInfoTranslation {
  public id: string;
  public trialId: string;
  public culture: string;
  public text: string;
  public globalLinkSupportText: string;
  public countryLinkSupportText: string;

  constructor(init?: Partial<TrialSupportInfoTranslation>) {
    Object.assign(this, init);
  }
}
